import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import initials from 'initials'
import trackEvents from '../../constants/track-events'
import { useNotificationContext, useUserContext } from '../../context'
import { mutation } from '../../graphql'
import { trackEvent } from '../../helpers/analytics'
import Button from '../tailwind/Button'
import Panel from '../tailwind/Panel'
import SectionHeading from '../tailwind/SectionHeading'
import SpaceCommentListItem from './space-comment-listitem'

const SpaceComment = ({ data }) => {
  const { t } = useTranslation()
  const { error } = useNotificationContext()
  const { activeSpace } = useUserContext()

  const { space, refetchSpace } = data

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [newComment, setNewComment] = useState('')

  const addNewComment = async (event) => {
    setIsSubmitting(true)
    event.preventDefault()

    const c = {
      person_id: activeSpace.person?.id,
      owner: activeSpace.owner,
      message: newComment,
      createdAt: new Date().toISOString()
    }

    const comment = space.comment || []
    comment.push(c)

    mutation({
      mutation: 'updateSpace',
      input: {
        id: space.id,
        comment
      }
    })
      .then(() => {
        trackEvent(trackEvents.COMMENT_TALENT)
        refetchSpace().then(() => {
          setIsSubmitting(false)
          setNewComment('')
        })
      })
      .catch(() => {
        error()
        setIsSubmitting(false)
      })
  }

  return (
    <Panel>
      <section aria-labelledby='notes-title'>
        <SectionHeading
          id='notes-title'
          title={t('pages.talent.notes')}
          description={t('pages.talent.notes_description')}
        />
        <div className='divide-y divide-gray-200 border-t border-gray-300'>
          {!isEmpty(space.comment) && (
            <div className='py-6'>
              <ul role='list' className='max-w-3xl space-y-8'>
                {space.comment.map((comment, index) => (
                  <SpaceCommentListItem key={index} comment={comment} />
                ))}
              </ul>
            </div>
          )}
          <div className='py-6'>
            <div className='flex space-x-3'>
              <div className='flex-shrink-0'>
                <span className='inline-flex size-10 items-center justify-center rounded-full bg-gray-400'>
                  <span className='font-medium leading-none text-white'>
                    {initials(
                      `${activeSpace.person.firstname} ${activeSpace.person.lastname}`
                    )}
                  </span>
                </span>
              </div>
              <div className='min-w-0 flex-1'>
                <form action='#'>
                  <div>
                    <label htmlFor='comment' className='sr-only'>
                      Comments
                    </label>
                    <textarea
                      id='comment'
                      name='comment'
                      rows={3}
                      className='block w-full rounded-md border border-gray-300 shadow-sm focus:border-primaryBlue focus:ring-primaryBlue sm:text-sm'
                      placeholder={t('pages.talent.comment_placeholder')}
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                    />
                  </div>
                  <div className='mt-3 flex items-center justify-end'>
                    <Button.PrimaryXL
                      text={t('pages.talent.comment')}
                      onClick={addNewComment}
                      disabled={!newComment}
                      isLoading={isSubmitting}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Panel>
  )
}

SpaceComment.propTypes = {
  data: PropTypes.object.isRequired
}

export default SpaceComment
